import { useState, useEffect } from 'react';
import { ProTable } from '@ant-design/pro-components';
import { Button, Space, App, Table, Modal } from 'antd';
import { theme } from 'antd';
import { costExceptionTabTableColumns } from './CostExceptionTabTableColumns';
import { 
    useGetAllCustomerUidQuery,
    useGetLogisticsServiceByNameQuery,
    useGetCostExceptionQuery,
    useCostExceptionBulkOperationBySelectMutation,
    useCostExceptionBulkOperationBySearchMutation,
    useGetBillingInvoiceNamesQuery,
 } from '../../features/api/apiSlice';
function CostExceptionTab() {
    const { token } = theme.useToken();
    const [searchData, setSearchData] = useState({});
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const { data, isLoading, isFetching } = useGetCostExceptionQuery(searchData);
    const { data: customerUidData, } = useGetAllCustomerUidQuery({}, {
        refetchOnMountOrArgChange: true,
    })
    const { data: logisticsService } = useGetLogisticsServiceByNameQuery({}, {
        refetchOnMountOrArgChange: true,
    });
    const { notification } = App.useApp();
    const [openSurcharge, setOpenSurcharge] = useState(false);
    const [modalContent, setModalContent] = useState(null);
    const { data: billingInvoiceNames } = useGetBillingInvoiceNamesQuery({}, {refetchOnMountOrArgChange: true});
    const columns = costExceptionTabTableColumns(customerUidData, logisticsService, setModalContent, setOpenSurcharge, billingInvoiceNames);
    const rowSelection = {
        selectedRowKeys,
        onChange: (selectedRowKeys) => {
            setSelectedRowKeys(selectedRowKeys);
        },
    }
    
    const [disputeCostExceptionWithSelect, {
        isLoading: isDisputing,
        isSuccess: isDisputeSuccess,
        isError: isDisputeError,
        error: disputeError,
    }] = useCostExceptionBulkOperationBySelectMutation();

    const [downloadCostExceptionWithSelect, {
        isLoading: isDownloading,
        isSuccess: isDownloadSuccess,
        isError: isDownloadError,
        error: downloadError,
    }] = useCostExceptionBulkOperationBySelectMutation();

    const [handleCostExceptionWithSelect, {
        isLoading: isHandling,
        isSuccess: isHandleSuccess,
        isError: isHandleError,
        error: handleError,
    }] = useCostExceptionBulkOperationBySelectMutation();

    const [disputeCostExceptionWithSearch, {
        isLoading: isDisputeBySearchLoading,
        isSuccess: isDisputeBySearchSuccess,
        isError: isDisputeBySearchError,
        error: disputeBySearchError,
    }] = useCostExceptionBulkOperationBySearchMutation();

    const [downloadCostExceptionWithSearch, {
        isLoading: isDownloadingBySearch,
        isSuccess: isDownloadSuccessBySearch,
        isError: isDownloadErrorBySearch,
        error: downloadErrorBySearch,
    }] = useCostExceptionBulkOperationBySearchMutation();


    const surcharge_columns = [
        {
            title: '费用类型',
            dataIndex: 'type',
            key: 'type'
        },
        {
            title: '金额',
            dataIndex: 'amount',
            key: 'amount'
        }
    ];

    const renderModalTable = () => {
        return <Table
            columns={surcharge_columns}
            dataSource={modalContent}
            pagination={false}
        />;
    };

    useEffect(() => {
        if (isDisputeBySearchSuccess) {
            notification.success({
                message: 'Dispute成功',
                description: 'Dispute成功',
            });
        }
        if (isDisputeBySearchError) {
            notification.error({
                message: 'Dispute失败',
                description: disputeBySearchError?.data?.message || 'Dispute失败, 请稍后重试',
            });
        }
    }, [isDisputeBySearchSuccess, isDisputeBySearchError, disputeBySearchError]);

    useEffect(() => {
        if (isDownloadSuccess) {
            notification.success({
                message: '下载成功',
                description: '下载成功,请前往后台任务管理获取文件',
            });
            setSelectedRowKeys([]);
        }
        if (isDownloadError) {
            console.error('Download error:', downloadError);
            notification.error({
                message: '下载失败',
                description: downloadError?.data?.error || '下载失败，请稍后重试',
            });
        }
    }, [isDownloadSuccess, isDownloadError, downloadError]);

    useEffect(() => {
        if (isDownloadSuccessBySearch) {
            notification.success({
                message: '下载成功',
                description: '下载成功,请前往后台任务管理获取文件',
            });
        }
        if (isDownloadErrorBySearch) {
            console.error('Download error:', downloadErrorBySearch);
            notification.error({
                message: '下载失败',
                description: downloadErrorBySearch?.data?.error || '下载失败，请稍后重试',
            });
        }
    }, [isDownloadSuccessBySearch, isDownloadErrorBySearch, downloadErrorBySearch]);

    useEffect(() => {
        if (isHandleSuccess) {
            notification.success({
                message: '异常已修复',
                description: '异常已修复',
            });
            setSelectedRowKeys([]);
        }
        if (isHandleError) {
            notification.error({
                message: '异常修复失败',
                description: handleError?.data?.message || '异常修复失败, 请稍后重试',
            });
        }
    }, [isHandleSuccess, isHandleError, handleError]);

    useEffect(() => {
        if (isDisputeSuccess) {
            notification.success({
                message: 'Dispute成功',
                description: 'Dispute成功',
            });
            setSelectedRowKeys([]);
        }
        if (isDisputeError) {
            notification.error({
                message: 'Dispute失败',
                description: disputeError?.data?.message || 'Dispute失败, 请稍后重试',
            });
        }
    }, [isDisputeSuccess, isDisputeError, disputeError]);

    const disputeButtonBySelectHandler = () => {
        const formData = new FormData();
        formData.append('exception_ids', selectedRowKeys);
        formData.append('operation', 'dispute');
        disputeCostExceptionWithSelect(formData);
    }

    const disputeButtonBySearchHandler = (searchConfig) => {
        searchConfig.form.validateFields().then((values) => {
            const request = {
                operation: "dispute",
                ...values,
            }
            disputeCostExceptionWithSearch(request);
        })
    }

    const exceptionHandlingButtonHandler = () => {
        const formData = new FormData();
        formData.append('exception_ids', selectedRowKeys);
        formData.append('operation', 'exception_handling');
        handleCostExceptionWithSelect(formData);
    }

    const downloadButtonHandler = () => {
        const formData = new FormData();
        formData.append('exception_ids', selectedRowKeys);
        formData.append('operation', 'download');
        downloadCostExceptionWithSelect(formData);
    }

    const downloadButtonBySearchHandler = (searchConfig) => {
        searchConfig.form.validateFields().then((values) => {
            const request = {
                operation: "download",
                ...values,
            }
            downloadCostExceptionWithSearch(request);
        })
    }

    return (
        <>
            <ProTable
                rowKey={(record) => record.id}
                search={{
                    span: { xs: 24, sm: 12, md: 8, lg: 8, xl: 8, xxl: 8 },
                    labelWidth: 'auto',
                    defaultCollapsed: false,
                    style: {
                        maxWidth: 'none',
                        background: token.colorFillAlter,
                        borderRadius: token.borderRadiusLG,
                        padding: 24,
                    },
                    optionRender: (searchConfig, formProps, dom) => [
                        <Button
                            key="disputeButton"
                            type="primary"
                            loading={isDisputeBySearchLoading}
                            onClick={() => disputeButtonBySearchHandler(searchConfig, formProps)}
                        >
                            Dispute
                        </Button>,
                        <Button
                            key="downloadButton"
                            type="primary"
                            loading={isDownloadingBySearch}
                            onClick={() => downloadButtonBySearchHandler(searchConfig, formProps)}
                        >
                            下载数据
                        </Button>,
                        ...dom,
                    ],
                }}
                rowSelection={rowSelection}
                tableAlertOptionRender={() => {
                    return (
                        <Space size='small'>
                            <Button type="link" loading={isDownloading} onClick={() => downloadButtonHandler()}>下载数据</Button>
                            <Button type="link" loading={isDisputing} onClick={() => { disputeButtonBySelectHandler() }}>Dispute</Button>
                            <Button type="link" loading={isHandling} onClick={() => { exceptionHandlingButtonHandler() }}>异常已修复</Button>
                            <Button type="link" onClick={() => { setSelectedRowKeys([]) }}>取消选择</Button>
                        </Space>
                    )
                }}
                columns={columns}
                manualRequest={true}
                request={(params) => {
                    setSearchData(params);
                }}
                loading={{
                    spinning: isLoading || isFetching,
                    tip: '数据加载中...',
                }}
                dataSource={data?.results}
                pagination={{
                    defaultPageSize: 10,
                    showSizeChanger: true,
                    pageSizeOptions: ['10', '20', '50', '100'],
                    total: data?.count,
                }}
                scroll={{ x: 'max-content' }}
            />
            <Modal
                title="附加费详情"
                open={openSurcharge}
                footer={null}
                onCancel={() => setOpenSurcharge(false)}
                width={800}
            >
                {renderModalTable()}

            </Modal>
        </>
    )
}

export default CostExceptionTab;